// The job-listings endpoint matches contract types by the exact names stored in the
// recruitment `job_offer_contract_type` table (seeded by migration
// 20250917085755_job_offer_contract_type), so the UI filter values must be
// translated into those names before querying. If those rows are ever renamed,
// this map must be updated in sync.
const CONTRACT_TYPE_NAMES_BY_FILTER_VALUE: Record<string, string[]> = {
  cdi: ['CDI'],
  cdd: ['CDD', 'CDD de remplacement', 'CDD sur poste vacant', "Contrat d'été"],
  stage: ['Stage (Contrat de stage)'],
  alternance: ["Alternance (Contrat d'alternance)"],
}

export const toContractTypeNamesParam = (
  contractTypes?: string,
): string | undefined => {
  if (!contractTypes) {
    return contractTypes
  }

  return contractTypes
    .split(',')
    .flatMap(
      (value) =>
        CONTRACT_TYPE_NAMES_BY_FILTER_VALUE[value.toLowerCase()] ?? [value],
    )
    .join(',')
}

// The endpoint filters departments by postal-code prefix; some INSEE codes do
// not prefix postal codes: both Corsican departments use 20xxx, and
// Saint-Barthélemy (977) / Saint-Martin (978) use Guadeloupe's 971xx — for the
// latter two the prefix cannot distinguish them from Guadeloupe itself.
const POSTAL_CODE_PREFIX_BY_DEPARTMENT: Record<string, string> = {
  '2A': '20',
  '2B': '20',
  '977': '971',
  '978': '971',
}

export const toDepartmentPostalPrefixParam = (
  department?: string,
): string | undefined => {
  if (!department) {
    return department
  }

  return POSTAL_CODE_PREFIX_BY_DEPARTMENT[department] ?? department
}
